import { memo } from 'react';
import useEnvironment from './useEnvironment';
import { useAsset } from '@artica/assets';
import {
  Color,
  EquirectangularReflectionMapping,
} from 'three';

const defaultColor = new Color(0.1, 0.15, 0.2);

export default memo(function Environment({ asset, background = defaultColor }) { 
  const texture = useAsset(asset);
  texture.mapping = EquirectangularReflectionMapping;
  
  useEnvironment(texture, background);

  return null;
});